// extracted by mini-css-extract-plugin
module.exports = {"content":"Success_content__1sVs3","url":"Success_url__224Ns","contentButton":"Success_contentButton__1YkNP"};